<div class="list-item">
  <div class="list-item-info">
    <div
      class="list-item-title-row"
      [class.list-item-title-row--inline]="titleInline"
    >
      <ng-content select="[beforeTitle]" />
      <span class="list-item-title">{{ title }}</span>
    </div>

    <ng-content select="[afterTitle]" />

    @if (subtitle) {
      <span class="list-item-subtitle">{{ subtitle }}</span>
    }
  </div>

  @if (shouldShowAction && actionLabel) {
    <umss-button
      [label]="actionLabel"
      [variant]="actionVariant"
      [size]="actionSize"
      [disabled]="actionDisabled"
      [loading]="actionLoading"
      [leftIconName]="actionLeftIconName"
      [rightIconName]="actionRightIconName"
      [iconSize]="actionIconSize"
      (click)="onActionClick()"
    />
  }
</div>
